export default __webpack_public_path__ + "media/images/ui-bg_glass_100_fdf5ce_1x400-9a6aae6a95e61b968ff869599bf14c1e.png";